import update from 'immutability-helper';

import {
    DATA_RECEIVED,
    FETCH_DATA,
} from '../actions/orders';

const initialState = {
    columns: ['level', 'ITEM_SECTOR', 'ASK', 'BID', 'ASKVOL', 'BIDVOL'],
    convert: 'levels',
    limit: 5,
    view: 'DELAYED',
};

export default function orders(state = initialState, action) {
    switch (action.type) {
    case DATA_RECEIVED:
        if (action.values) {
            // The key returned is on the form STL_OSE000001, where the padded number
            // after the symbol is the order in which to list the data.
            // Thus, taking the last number and subtracting 1 will give the appropriate
            // array index.
            const index = (action.key.slice(-1) || 1) - 1;

            return update(state, {
                [action.meta.symbol]: {
                    orders: {
                        [index]: { $merge: action.values },
                    },
                },
            });
        }

        return state;

    case FETCH_DATA.REQUEST:
        return Object.assign({}, state, {
            [action.meta.symbol]: Object.assign({},
                state[action.meta.symbol] || [],
                { isLoading: true },
            ),
        });

    case FETCH_DATA.SUCCESS:
        if (action.payload) {
            return Object.assign({}, state, {
                [action.meta.symbol]: {
                    orders: action.payload.map(
                        order => order.values
                    ),
                    isLoading: false,
                },
            });
        }
        return state;

    case FETCH_DATA.FAILURE:
        return {
            [action.meta.symbol]: { isLoading: false },
        };

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/orders.js
 **/